if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

(() => {
  const swatchMap = {
    antique: 'antique',
    blush: 'blush',
    charcoal: 'charcoal',
    cream: 'cream',
    limestone: 'limestone',
    linen: 'linen',
    oyster: 'oyster',
    plaza: 'plaza',
    seagrass: 'seagrass',
    sienna: 'sienna'
  };

  const normalizeSwatchText = (text) => text.toLowerCase().trim().replace(/\s+/g, ' ');

  const swatchUrlFromTemplate = (templateUrl, family, colour) => {
    const filename = `swatch-${family}-${colour}.jpg`;
    if (/swatch-[a-z0-9-]+-[a-z0-9-]+\.jpg/i.test(templateUrl)) {
      return templateUrl.replace(/swatch-[a-z0-9-]+-[a-z0-9-]+\.jpg/i, filename);
    }
    return templateUrl;
  };

  const ensureFabricSwatches = () => {
    document.querySelectorAll('fieldset.product-form__input').forEach((fieldset) => {
      const templateLabel = fieldset.querySelector('.fabric-swatch-label[data-fabric-family] img');
      const family = fieldset.querySelector('.fabric-swatch-label[data-fabric-family]')?.dataset.fabricFamily;

      if (!templateLabel || !family) return;

      fieldset.querySelectorAll('label').forEach((label) => {
        const rawText = label.querySelector('.fabric-swatch-label__text')?.textContent || label.textContent;
        const colour = swatchMap[normalizeSwatchText(rawText)];

        if (!colour) return;

        const swatchUrl = swatchUrlFromTemplate(templateLabel.currentSrc || templateLabel.src, family, colour);
        const existingImage = label.querySelector('.fabric-swatch-label__image');

        label.classList.add('fabric-swatch-label');
        label.dataset.fabricFamily = family;
        label.dataset.swatchColour = colour;
        label.title = rawText.trim();

        if (existingImage) {
          existingImage.src = swatchUrl;
          return;
        }

        label.textContent = '';

        const imageWrap = document.createElement('span');
        imageWrap.className = 'fabric-swatch-label__image-wrap';

        const image = document.createElement('img');
        image.className = 'fabric-swatch-label__image';
        image.src = swatchUrl;
        image.alt = '';
        image.width = 48;
        image.height = 48;
        image.loading = 'lazy';
        image.addEventListener('error', () => {
          label.classList.add('fabric-swatch-label--missing');
          image.remove();
        });

        const text = document.createElement('span');
        text.className = 'fabric-swatch-label__text';
        text.textContent = rawText.trim();

        imageWrap.appendChild(image);
        label.append(imageWrap, text);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureFabricSwatches);
  } else {
    ensureFabricSwatches();
  }
})();
